import { render, staticRenderFns } from "./LayoutBackoffice.vue?vue&type=template&id=33dc3974&"
import script from "./LayoutBackoffice.vue?vue&type=script&lang=js&"
export * from "./LayoutBackoffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports